import React from "react";
import Icon from "../icon/Icon";
import classNames from "classnames";
import stylesCH from "../../gui/customHeader/CustomHeader.module.scss";

export default function HeaderLogo({width, height, props}) {
  return (
    <a {...props}
       className={classNames('header__logo custom-header__logo', stylesCH.customHeader__logo, props?.className)}>
      <Icon name={props.icon} width={width} height={height}/>
    </a>
  )
}
